<template>
  <div id="app">
    <heard v-if="!ishome" @showuserinfo="showinfo"></heard>
    <router-view />
    <userinfo-model ref="userinfo"></userinfo-model>
    <reset-password></reset-password>
    <imgprivew></imgprivew>
    <div class="alibabfont">..</div>
  </div>
</template>

<script>
import heard from '@/components/heard/index';
import userinfoModel from '@/components/userinfo/index';
import resetPassword from '@/components/resetPassword';
import imgprivew from '@/components/imgprivew';

export default {
  name: 'App',
  components: {
    heard,
    userinfoModel,
    resetPassword,
    imgprivew
  },
  data() {
    return {
    };
  },
  computed: {
    ishome: function () {
      return this.$route.name === '首页';
    }
  },
  methods: {
    showinfo() {
      this.$nextTick(() => {
        this.$refs.userinfo.visible = true;
      });
    }
  },
  mounted() {
    this.$bus.$on('showinfo', (value) => {
      console.log(value);
      this.showinfo();
    });
  },
  created() {
    // 先检查sessionStorage中是否有数据，若存在数据则加载到vuex
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      );
      sessionStorage.removeItem('store');
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  }
};
</script>

<style>
@import url(../static/css/reset.css);
@import url(../static/css/fashion.css);
</style>



// WEBPACK FOOTER //
// src/App.vue